import { render, staticRenderFns } from "./OrderPrintPage1.vue?vue&type=template&id=1bec09c7&"
import script from "./OrderPrintPage1.vue?vue&type=script&lang=js&"
export * from "./OrderPrintPage1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports